<template>
	<main id="main" class="main-site">
		<div class="container">
			<div class="row" style="margin-top: 30px">
				<div class="main-content-area">
					<div class="wrap-login-item">
						<div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
							<div class="form-item">
								<form @submit.prevent="auth" name="frm-auth" method="post" >
									<fieldset class="wrap-title">
										<h3 class="form-title">Integração com RDStation</h3>
									</fieldset>
									<fieldset>
										<div class="alert alert-warning" role="alert">
											<i class="fa fa-warning"></i>
											Página exclusiva para área de TI e infraestrutura da Aldo.
										</div>
									</fieldset>
									<fieldset class="wrap-input" style="margin-top: 30px">
										<label>Client ID <span class="required">*</span></label>
										<input type="text" v-model="formAuth.clientID" placeholder="Client ID *">
									</fieldset>
									<fieldset>
										<div class="alert alert-info" role="alert">
											O ClientID do aplicativo pode ser obtido na RDStation AppStore.
										</div>
									</fieldset>
									<fieldset class="wrap-input">
										<label>Url de Callback <span class="required">*</span></label>
										<input type="text" id="frm-reg-lname" name="reg-lname" v-model="formAuth.callbackUrl" placeholder="Url de Callback *">
									</fieldset>
									<input type="submit" class="btn" value="Avançar">
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
export default {
  name: 'rdstation-integracao',
  data(){
	return {
		formAuth: {
			clientID: '',
			callbackUrl: '',
			attemptSubmit: false
		}
	}
  },
  methods: {
	auth: function() {
		if (!this.formAuth.clientID || !this.formAuth.callbackUrl)
			return;

		location.href = `https://app.rdstation.com.br/api/platform/auth?client_id=${this.formAuth.clientID}&redirect_url=${this.formAuth.callbackUrl}`;
	}
  }
}
</script>